import { render } from "./EditInfosComponent.vue?vue&type=template&id=41a10e54&scoped=true"
import script from "./EditInfosComponent.vue?vue&type=script&lang=js"
export * from "./EditInfosComponent.vue?vue&type=script&lang=js"

import "./EditInfosComponent.vue?vue&type=style&index=0&id=41a10e54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41a10e54"]])

export default __exports__